import * as React from "react";

const PlusIcon = (props) => {
  return (
    <svg
      width={16}
      height={17}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 10H2" stroke="#FFF" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 4V16" stroke="#FFF" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  );
}

export default PlusIcon